// extracted by mini-css-extract-plugin
export var border = "_1j-7";
export var brand = "_1j-s";
export var button = "_1j-k";
export var center = "_1j-9";
export var centered = "_1j-5";
export var closeButton = "_1j-b";
export var disabledWrapper = "_1j-l";
export var error = "_1j-o";
export var extraLarge = "_1j-4";
export var extraSmall = "_1j-1";
export var fill = "_1j-h";
export var footer = "_1j-g";
export var footerAction = "_1j-i";
export var footerButtons = "_1j-j";
export var header = "_1j-6";
export var headerWithClose = "_1j-c";
export var icon = "_1j-n";
export var info = "_1j-r";
export var inline = "_1j-8";
export var large = "_1j-3";
export var main = "_1j-d";
export var modal = "_1j-0";
export var neutral = "_1j-t";
export var noPadding = "_1j-f";
export var none = "_1j-u";
export var scrollable = "_1j-e";
export var small = "_1j-2";
export var success = "_1j-q";
export var tight = "_1j-m";
export var titleIcon = "_1j-a";
export var warn = "_1j-p";